/**
 * FORMAT-DATE.UTILS
 * Replace occurence for email
 */

import { store } from "@/index"
import { DEFAULT_FILTERS, Filter } from "@/redux/filter.types"
import { t } from "@/translate/t"
import { getCompanyFilterName } from "@/utils/observer-scope-options.utils"

const initFilters = (hideDefault?: boolean, hideCompany?: boolean) => {
  //Get current redux store
  const state = store.getState()

  //Get default filters
  let filters = hideDefault ? [] : DEFAULT_FILTERS.map((x) => new Filter(x))

  if (state.survey.active.randomData) {
    filters = filters.concat(new Filter({ name: t("filter_random_title") }))
  } else {
    if (!hideCompany) {
      filters = filters.concat(
        new Filter({
          id: "company",
          name: getCompanyFilterName(state._session),
          default: true
        })
      )
    }
    filters = filters.concat(state.filter.list)
  }

  if (state._session.userExcludedFilters) {
    filters = filters.filter((x) => state._session.userExcludedFilters.indexOf(x.name) === -1)
  }

  filters = state._session.getVisibleFilters(filters, state.survey.active.id)

  return filters
}

export default initFilters
